import React, { useContext } from 'react'
import slugify from 'react-slugify'

import MomentUtils from '@date-io/moment'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import moment from 'moment'
import Context from '../../context'

function ChallengeData() {
  const { formObject, setFormObject } = useContext(Context)

  const onBlurToSlug = str => {
    setFormObject({ ...formObject, slug: slugify(str) })
  }

  return (
    <>
      <h5>Dados do Desafio</h5>
      <br />
      <div className="row">
        <div className="col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="title">Título</label>
          <input
            value={formObject.title || ''}
            onChange={e => setFormObject({ ...formObject, title: e.target.value })}
            onBlur={e => onBlurToSlug(e.target.value)}
            type="text"
            className="form-control"
            id="title"
            placeholder="Título"
          />
        </div>
        <div className="col-md-6 col-sm-12" style={{ marginBottom: '20px' }}>
          <label htmlFor="slug">Slug</label>
          <input
            value={formObject.slug || ''}
            onChange={e => setFormObject({ ...formObject, slug: e.target.value })}
            onBlur={e => onBlurToSlug(e.target.value)}
            type="text"
            className="form-control"
            id="slug"
            placeholder="Slug"
          />
        </div>
        <div className="col-12 form-group" style={{ marginBottom: '20px' }}>
          <label htmlFor="description">Descrição do Desafio</label>
          <textarea
            className="form-control"
            id="description"
            rows="5"
            placeholder="Descrição do Desafio"
            value={formObject.description || ''}
            onChange={e => setFormObject({ ...formObject, description: e.target.value })}
          />
        </div>
        <div className="col-md-2 col-sm-4 form-group" style={{ marginBottom: '20px' }}>
          <label htmlFor="description">Data de início</label>
          <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
            <KeyboardDatePicker
              style={{ display: 'block' }}
              margin="normal"
              id="startDate"
              format="DD/MM/YYYY"
              value={formObject.startDate || undefined}
              onChange={date => setFormObject({ ...formObject, startDate: date })}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </MuiPickersUtilsProvider>
        </div>
        <div className="col-md-2 col-sm-4 form-group" style={{ marginBottom: '20px' }}>
          <label htmlFor="description">Data de fim</label>
          <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
            <KeyboardDatePicker
              style={{ display: 'block' }}
              margin="normal"
              id="endDate"
              format="DD/MM/YYYY"
              value={formObject.endDate || undefined}
              onChange={date => setFormObject({ ...formObject, endDate: date })}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
              minDate={formObject.startDate}
              minDateMessage="A Data final não pode ser inferior ao início."
            />
          </MuiPickersUtilsProvider>
        </div>
        <div
          className="col-md-2 col-sm-4 form-group"
          style={{ marginBottom: '20px', paddingRight: 5 }}
        >
          <label htmlFor="type">Tipo de Desafio</label>
          <select
            className="form-control"
            style={{ marginTop: 10 }}
            id="type"
            value={formObject.type}
            onChange={e => setFormObject({ ...formObject, type: e.target.value })}
          >
            <option value="1">Primeiro</option>
            <option value="2">Segundo</option>
            <option value="3">Terceiro</option>
          </select>
        </div>
      </div>
    </>
  )
}

export default ChallengeData
